var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"a-back-button back-button",style:(_vm.componentStyles),on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.$t(_vm.componentParams.title))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }